const steps = [
  {
    number: '01',
    title: 'Trova categoria',
    description: 'Naviga tra le categorie disponibili e seleziona quella che ti interessa di più per iniziare la tua ricerca.',
    icon: 'ri-compass-3-line',
  },
  {
    number: '02',
    title: 'Analizza prodotti',
    description: 'Esamina le tabelle dettagliate con foto, prezzi e descrizioni per valutare ogni prodotto con attenzione.',
    icon: 'ri-bar-chart-2-line',
  },
  {
    number: '03',
    title: 'Controlla informazioni',
    description: 'Verifica la qualità attraverso le foto QC e confronta i dati per fare scelte consapevoli e informate.',
    icon: 'ri-file-search-line',
  },
  {
    number: '04',
    title: 'Consulta risorse',
    description: 'Accedi alle guide complete e alle risorse aggiornate per approfondire e migliorare la tua esperienza.',
    icon: 'ri-book-open-line',
  },
];

export default function HowItWorks() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-foreground-400 mb-3 block">
            Processo
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
            Come funziona Itaobuy Spreadsheet?
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            Quattro semplici passaggi per iniziare a utilizzare Itaobuy Spreadsheet al meglio
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {steps.map((step, i) => (
            <div key={i} className="relative group">
              <div className="bg-white rounded-2xl border border-background-200/70 p-6 md:p-7 hover:border-accent-200 transition-all cursor-default">
                <span className="font-heading text-5xl font-bold text-background-300 absolute -top-2 -left-1 select-none">
                  {step.number}
                </span>
                <div className="relative z-10">
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-5 group-hover:bg-accent-500 group-hover:text-white transition-all">
                    <i className={`${step.icon} text-xl`}></i>
                  </div>
                  <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">
                    {step.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}